export const paymentEndpoints = {
  getPaymentPlans: "/payment/payment-plans/",
  postValidateReceipt: "/payment/validate-receipt/",
  postGoogleReceipt: "/payment/google-receipt/",
  getPaymentCheck: "/auth/payment-check/",
  getZiinaUser: "/ziina/ziina-user/",
  postStripeCheckCoupon: "/payment/stripe-check-coupon/",
};
